export enum NOTIFICATION_EVENT_TYPE {
	APPLICATION_STATUS_CHANGE = 'APPLICATION_STATUS_CHANGE',
	APPEAL_STATUS_CHANGE = 'APPEAL_STATUS_CHANGE',
	APPLICATION_COMMENT = 'APPLICATION_COMMENT',
	APPEAL_COMMENT = 'APPEAL_COMMENT',
	SYSTEM_GENERATED_EMAIL = 'SYSTEM_GENERATED_EMAIL'
}
